import { render, staticRenderFns } from "./inventory_detail.vue?vue&type=template&id=b303b5f6&scoped=true"
import script from "./inventory_detail.vue?vue&type=script&lang=js"
export * from "./inventory_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b303b5f6",
  null
  
)

export default component.exports